import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import { createPinia } from "pinia";
import piniaPersist from "pinia-plugin-persistedstate";
import { Icon } from '@iconify/vue';


import BaseDialog from './components/BaseDialog.vue';
import BaseButton from './components/BaseButton.vue';

import VueGoodTablePlugin from 'vue-good-table-next';
import 'vue-good-table-next/dist/vue-good-table-next.css';
import VueNextSelect from 'vue-next-select';
import 'vue-next-select/dist/index.min.css';
import VueDatePicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';



const app = createApp(App);

app.component('base-dialog', BaseDialog);
app.component('base-button', BaseButton);
app.component('app-icon', Icon);
app.component('vue-select', VueNextSelect);
app.component('vue-datepicker', VueDatePicker);

app.use(router);
const pinia = createPinia();
pinia.use(piniaPersist);

app.use(VueGoodTablePlugin);
app.use(pinia);
app.mount('#app');

